module.exports = __webpack_public_path__ + "static/media/bg-seoul-univ-thumbnail.2ebfb625.jpg";